import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="completed-tasks"
export default class extends Controller {
    static targets = ["task", "label", "track", "knob"]
    static values = {
        shown: Boolean,
        hiddenLabel: String,
        shownLabel: String
    }

    toggle() {
        this.shownValue = !this.shownValue;
    }

    shownValueChanged() {
        for (const task of this.taskTargets) {
            if (!this.completed(task)) { continue; }

            task.classList.toggle('hidden', !this.shownValue);
        }

        if (!this.hasLabelTarget) { return; }

        this.labelTarget.innerHTML = this.shownValue ? this.shownLabelValue : this.hiddenLabelValue;

        this.trackTarget.classList.toggle('bg-emerald-500', this.shownValue);
        this.trackTarget.classList.toggle('bg-gray-200', !this.shownValue);
        this.knobTarget.classList.toggle('translate-x-5', this.shownValue);
        this.knobTarget.classList.toggle('translate-x-0', !this.shownValue);
    }

    // Read off the checkbox rather than the markup so a task ticked complete after the modal
    // was opened still gets hidden when the completed tasks are toggled away.
    completed(task) {
        const checkbox = task.querySelector('input[type="checkbox"]');

        return checkbox ? checkbox.checked : false;
    }
}
